import Axios from "axios"
import store from '../store'

export default {
  getWebapigwUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE
  },
  getClientId() {
    return store.getters['Client/clientId']
  },
  getOccupancyStatus(payload){
    return Axios.get(`${this.getWebapigwUrl()}/api/v1/clients/${this.getClientId()}/sites/${payload.siteId}/locations/${payload.locationId}/space-occupancies`, {
      ignoreGlobalCatch: true,
    })
  }
}
